import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ClaimInsentifPageRoutingModule } from './claim-insentif-routing.module';

import { ClaimInsentifPage } from './claim-insentif.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ClaimInsentifPageRoutingModule
  ],
  declarations: [ClaimInsentifPage]
})
export class ClaimInsentifPageModule {}
